// extracted by mini-css-extract-plugin
export default {"Box":"repo-list-module__Box--mWL3k","Text":"repo-list-module__Text--yvwT8"};